var _defs, _path, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForgotpassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Layer",
    width: 22.874,
    height: 22.037,
    viewBox: "0 0 22.874 22.037",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:#3f66b3}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trazado_84",
    d: "M10.94 9.33a1.043 1.043 0 0 1 2.083 0v5.92a1.043 1.043 0 0 1-2.083 0z",
    className: "prefix__cls-1",
    "data-name": "Trazado 84",
    transform: "translate(-.597 -.963)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "prefix__Elipse_6",
    cx: 1.302,
    cy: 1.25,
    className: "prefix__cls-1",
    "data-name": "Elipse 6",
    rx: 1.302,
    ry: 1.25,
    transform: "translate(10.083 16.357)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trazado_85",
    d: "M12.593 4.32a.212.212 0 0 0-.375 0L3.75 20.75a.193.193 0 0 0 .009.2.21.21 0 0 0 .178.095h17.031a.21.21 0 0 0 .178-.095.193.193 0 0 0 .009-.2zm-1.312-2.69a1.274 1.274 0 0 1 2.24 0L23.77 21.3a1.158 1.158 0 0 1-.078 1.139 1.262 1.262 0 0 1-1.036.561H2.26a1.252 1.252 0 0 1-1.06-.564 1.149 1.149 0 0 1-.05-1.166z",
    "data-name": "Trazado 85",
    transform: "translate(-1.01 -.963)",
    style: {
      fillRule: "evenodd",
      fill: "#3f66b3"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotpassword);
export default __webpack_public_path__ + "static/media/forgotpassword.34dca70a63e3d2fe12488f1cf929a998.svg";
export { ForwardRef as ReactComponent };